/* ============================================================
   LXPERFUME — shared runtime V2 (Shopify theme edition)
   Lenis + GSAP ScrollTrigger + FX engine + shared chrome
   Cart = native Shopify AJAX Cart API
   Page templates define window.LX_PAGE_INIT; this file boots it.
   ============================================================ */
window.LX = (function () {
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));
  const money = (n) => "$" + Number(n).toFixed(2);
  /* size a Shopify CDN image URL: replace an existing width param or append one */
  const imgW = (u, w) => {
    u = u || "";
    if (!u) return u;
    return /[?&]width=\d+/.test(u)
      ? u.replace(/([?&])width=\d+/, "$1width=" + w)
      : u + (u.indexOf("?") > -1 ? "&" : "?") + "width=" + w;
  };

  const URLS = {
    home: "/",
    shop: "/collections/all",
    bestsellers: "/collections/all?f=bestsellers",
    edit: "/pages/the-edit",
    about: "/pages/lx-about-us",
    faq: "/pages/faq",
    contact: "/pages/contact",
    quiz: "/pages/scent-match",
    atelier: "/pages/the-atelier",
    product: (h) => "/products/" + h,
  };

  /* ---------- catalog helpers ---------- */
  const P = window.LX_PRODUCTS || [];
  const V = window.LX_VIDEOS || {};
  const byHandle = (h) => P.find((p) => p.handle === h);
  const videoOf = (p) => V[typeof p === "string" ? p : p.handle] || null;
  /* the designer house + fragrance, written in full — never the fragrance name alone */
  const INSPIRED_MAP = {
    "pure-blossom-flowerbomb-inspired-perfume": "Viktor&Rolf's Flowerbomb",
    "ruby-embrace-inspired-by-tom-ford-s-lost-cherry": "Tom Ford's Lost Cherry",
    "after-dark": "Carolina Herrera's Good Girl",
    "noir-santal-inspired-by-santal-33": "Le Labo's Santal 33",
    "blush-desire-inspired-by-love-dont-be-shy": "Kilian's Love, Don't Be Shy",
    "midnight-silk": "YSL's Black Opium",
    "royal-legend-inspired-by-creed-aventus": "Creed's Aventus",
    "royal-whisper-inspired-by-baccarat-rouge-540": "Maison Francis Kurkdjian's Baccarat Rouge 540",
    "azure-breeze-inspired-by-dolce-gabbana-light-blue": "Dolce & Gabbana's Light Blue",
    "free-spirit-inspired-by-ysl-libre": "YSL's Libre",
    "wild-legend-inspired-by-dior-sauvage": "Dior's Sauvage",
    "garden-aura-inspired-by-gucci-bloom": "Gucci's Bloom",
    "amber-essence-inspired-by-chanel-coco-mademoiselle": "Chanel's Coco Mademoiselle",
    "radiant-aura": "Dior's J'Adore",
    "velvet-spice-tobacco-vanille-inspired": "Tom Ford's Tobacco Vanille",
    "sapphire-essence-inspired-by-bleu-de-chanel": "Chanel's Bleu de Chanel",
    "golden-meadow-inspired-by-marc-jacobs-daisy": "Marc Jacobs's Daisy",
    "enigma-essence-inspired-by-mugler-alien": "Mugler's Alien",
    "oud-royale-inspired-by-tom-ford-oud-wood": "Tom Ford's Oud Wood",
    "nightfall-essence": "Tom Ford's Black Orchid",
    "velvet-rose-eau-de-parfum": "Parfums de Marly's Delina",
    "aquatic-icon-inspired-by-armani-acqua-di-gio": "Giorgio Armani's Acqua Di Gio",
    "signature-blanc-perfume-inspired-by-chanel-no-5": "Chanel's No. 5",
    "mythic-legend": "Versace's Eros",
    "amber-hearth-inspired-by-maison-margiela-by-the-fireplace": "Maison Margiela's By the Fireplace",
    "platinum-silk-byredo-gypsy-water-inspired": "Byredo's Gypsy Water",
    "velvet-nectar-bitter-peach-inspired": "Tom Ford's Bitter Peach",
    "snowtrace-inspired-by-creed-silver-mountain-water": "Creed's Silver Mountain Water",
    "whisper-gaia-inspired-by-louis-vuitton-ombre-nomade": "Louis Vuitton's Ombre Nomade",
    "whisper-dusk-mojave-ghost-inspired": "Byredo's Mojave Ghost",
    "solar-bloom-inspired-by-tom-ford-soleil-blanc": "Tom Ford's Soleil Blanc",
    "imperial-gold-millesime-imperial-inspired": "Creed's Millésime Impérial",
    "golden-whisper-inspired-by-aventus-for-her": "Creed's Aventus for Her",
    "veloura-ember": "Kilian's Angels’ Share",
    "ocean-vision": "Louis Vuitton's Imagination",
    "rogue-affair-inspired-by-tom-ford-fabulous": "Tom Ford's F***ing Fabulous",
    "tavrak-ember-inspired-by-tom-ford-ombre-leather": "Tom Ford's Ombré Leather",
    "lunarev-inspired-by-dior-sauvage-elixir": "Dior's Sauvage Elixir",
    "mirelor-inspired-by-armani-stronger-with-you": "Emporio Armani's Stronger With You",
    "velorune-inspired-by-stronger-with-you-intensely": "Emporio Armani's Stronger With You Intensely",
    "ovelior-inspired-by-orto-parisi-megamare": "Orto Parisi's Megamare",
    "celorin-inspired-by-amouage-guidance": "Amouage's Guidance",
    "orivale-inspired-by-kilian-apple-brandy-on-the-rocks": "Kilian's Apple Brandy on the Rocks",
    "zenvor-inspired-by-kilian-smoking-hot": "Kilian\'s Smoking Hot",
    "alviren-inspired-by-valentino-born-in-roma": "Valentino's Born in Roma",
    "torvane-inspired-by-arabian-oud-madawi": "Arabian Oud's Madawi",
  };
  const inspiredOf = (p) => {
    if (INSPIRED_MAP[p.handle] !== undefined) return INSPIRED_MAP[p.handle];
    const t = (p.tags || []).find((x) => / Inspired$/i.test(x));
    if (t) return t.replace(/ Inspired$/i, "");
    const m = p.desc && p.desc.match(/[Ii]nspired by ([A-Za-z0-9'’&\- ]{3,40})/);
    if (!m) return "";
    let s = m[1].split(/\s{2,}/)[0]
      .replace(/([a-z0-9])(Concentration|Notes|Scent|Experience|Longevity)\b.*$/, "$1")
      .replace(/\s+(Concentration|Notes|Scent|Experience|Longevity|A|The)\b.*$/i, "").trim();
    const words = s.split(" ");
    if (words.length > 5) s = words.slice(0, 5).join(" ");
    return s.trim();
  };
  // gender per the live lxperfume.com collection page (many products lack gender: tags)
  const GENDER_MAP = {
    women: ["after-dark", "amber-essence-inspired-by-chanel-coco-mademoiselle", "azure-breeze-inspired-by-dolce-gabbana-light-blue", "blush-desire-inspired-by-love-dont-be-shy", "enigma-essence-inspired-by-mugler-alien", "free-spirit-inspired-by-ysl-libre", "garden-aura-inspired-by-gucci-bloom", "golden-meadow-inspired-by-marc-jacobs-daisy", "golden-whisper-inspired-by-aventus-for-her", "midnight-silk", "pure-blossom-flowerbomb-inspired-perfume", "radiant-aura", "signature-blanc-perfume-inspired-by-chanel-no-5", "velvet-rose-eau-de-parfum"],
    men: ["aquatic-icon-inspired-by-armani-acqua-di-gio", "mythic-legend", "ocean-vision", "royal-legend-inspired-by-creed-aventus", "sapphire-essence-inspired-by-bleu-de-chanel", "wild-legend-inspired-by-dior-sauvage"],
  };
  const genderOf = (p) => {
    const t = (p.tags || []).find((x) => x.startsWith("gender:"));
    if (t) return t.split(":")[1];
    if (GENDER_MAP.women.includes(p.handle)) return "women";
    if (GENDER_MAP.men.includes(p.handle)) return "men";
    return "unisex";
  };
  const familyOf = (p) => {
    const t = (p.tags || []).find((x) => x.startsWith("scent-"));
    return t ? t.replace("scent-", "") : "signature";
  };
  const seed = (str) => { let h = 0; for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) >>> 0; return h; };
  // internal popularity weights for ordering only — never displayed
  const POPULARITY_MAP = {
    "after-dark": 306, "amber-essence-inspired-by-chanel-coco-mademoiselle": 267,
    "amber-hearth-inspired-by-maison-margiela-by-the-fireplace": 745,
    "aquatic-icon-inspired-by-armani-acqua-di-gio": 452,
    "noir-santal-inspired-by-santal-33": 1746, "ocean-vision": 631,
    "oud-royale-inspired-by-tom-ford-oud-wood": 2133,
    "royal-legend-inspired-by-creed-aventus": 1652,
    "royal-whisper-inspired-by-baccarat-rouge-540": 2147,
    "ruby-embrace-inspired-by-tom-ford-s-lost-cherry": 1210,
    "tavrak-ember-inspired-by-tom-ford-ombre-leather": 67, "veloura-ember": 101,
    "velvet-nectar-bitter-peach-inspired": 725, "velvet-spice-tobacco-vanille-inspired": 181,
    "wild-legend-inspired-by-dior-sauvage": 2216,
  };
  const popularityOf = (p) => POPULARITY_MAP[p.handle] || 120 + (seed(p.handle) % 900);

  /* verified retail price of the original, from the brand's own site or an authorised
     retailer. No entry = no verified price = we show no comparison at all. */
  const RETAIL_MAP = {
    "whisper-gaia-inspired-by-louis-vuitton-ombre-nomade": 520,
    "lunarev-inspired-by-dior-sauvage-elixir": 265,
    "mirelor-inspired-by-armani-stronger-with-you": 120,
    "velorune-inspired-by-stronger-with-you-intensely": 130,
    "ovelior-inspired-by-orto-parisi-megamare": 205,
    "celorin-inspired-by-amouage-guidance": 395,
    "orivale-inspired-by-kilian-apple-brandy-on-the-rocks": 415,
    "zenvor-inspired-by-kilian-smoking-hot": 305,
    "alviren-inspired-by-valentino-born-in-roma": 180,
    "torvane-inspired-by-arabian-oud-madawi": 250,
    "pure-blossom-flowerbomb-inspired-perfume": 182,
    "ruby-embrace-inspired-by-tom-ford-s-lost-cherry": 630,
    "after-dark": 164,
    "noir-santal-inspired-by-santal-33": 348,
    "blush-desire-inspired-by-love-dont-be-shy": 450,
    "midnight-silk": 172,
    "royal-legend-inspired-by-creed-aventus": 510,
    "royal-whisper-inspired-by-baccarat-rouge-540": 360,
    "azure-breeze-inspired-by-dolce-gabbana-light-blue": 148,
    "free-spirit-inspired-by-ysl-libre": 180,
    "wild-legend-inspired-by-dior-sauvage": 135,
    "garden-aura-inspired-by-gucci-bloom": 168,
    "amber-essence-inspired-by-chanel-coco-mademoiselle": 185,
    "radiant-aura": 180,
    "velvet-spice-tobacco-vanille-inspired": 460,
    "sapphire-essence-inspired-by-bleu-de-chanel": 173,
    "golden-meadow-inspired-by-marc-jacobs-daisy": 142,
    "enigma-essence-inspired-by-mugler-alien": 185,
    "oud-royale-inspired-by-tom-ford-oud-wood": 460,
    "nightfall-essence": 240,
    "golden-whisper-inspired-by-aventus-for-her": 460,
    "imperial-gold-millesime-imperial-inspired": 490,
    "snowtrace-inspired-by-creed-silver-mountain-water": 490,
    "platinum-silk-byredo-gypsy-water-inspired": 330,
    "whisper-dusk-mojave-ghost-inspired": 330,
    "solar-bloom-inspired-by-tom-ford-soleil-blanc": 460,
    "tavrak-ember-inspired-by-tom-ford-ombre-leather": 240,
    "rogue-affair-inspired-by-tom-ford-fabulous": 630,
    "velvet-nectar-bitter-peach-inspired": 405,
    "veloura-ember": 415,
    "ocean-vision": 360,
    "velvet-rose-eau-de-parfum": 410,
    "amber-hearth-inspired-by-maison-margiela-by-the-fireplace": 170,
    "mythic-legend": 120,
    "aquatic-icon-inspired-by-armani-acqua-di-gio": 130,
    "signature-blanc-perfume-inspired-by-chanel-no-5": 190,
  };
  const retailOf = (p) => RETAIL_MAP[p.handle] || 0;   /* 0 = unknown -> caller must hide the anchor */
  /* the size that retail price refers to, when the original is not sold in 100 ml */
  const RETAIL_SIZE = {
    "whisper-gaia-inspired-by-louis-vuitton-ombre-nomade": "100 ml",
    "zenvor-inspired-by-kilian-smoking-hot": "50 ml",
    "ovelior-inspired-by-orto-parisi-megamare": "50 ml",
    "torvane-inspired-by-arabian-oud-madawi": "90 ml",
    "after-dark": "80 ml",
    "midnight-silk": "90 ml",
    "royal-whisper-inspired-by-baccarat-rouge-540": "70 ml",
    "free-spirit-inspired-by-ysl-libre": "90 ml",
    "enigma-essence-inspired-by-mugler-alien": "90 ml",
    "golden-whisper-inspired-by-aventus-for-her": "75 ml",
    "velvet-nectar-bitter-peach-inspired": "50 ml",
    "velvet-rose-eau-de-parfum": "75 ml",
  };
  const retailSizeOf = (p) => RETAIL_SIZE[p.handle] || "";

  /* the Layering Room — curated pairs, auto-completed by shared mood + contrasting family */
  const LAYER_MAP = {
    "royal-whisper-inspired-by-baccarat-rouge-540": ["oud-royale-inspired-by-tom-ford-oud-wood", "ruby-embrace-inspired-by-tom-ford-s-lost-cherry"],
    "royal-legend-inspired-by-creed-aventus": ["oud-royale-inspired-by-tom-ford-oud-wood", "noir-santal-inspired-by-santal-33"],
    "oud-royale-inspired-by-tom-ford-oud-wood": ["velvet-spice-tobacco-vanille-inspired", "royal-whisper-inspired-by-baccarat-rouge-540"],
    "wild-legend-inspired-by-dior-sauvage": ["noir-santal-inspired-by-santal-33", "aquatic-icon-inspired-by-armani-acqua-di-gio"],
    "ruby-embrace-inspired-by-tom-ford-s-lost-cherry": ["velvet-nectar-bitter-peach-inspired", "royal-whisper-inspired-by-baccarat-rouge-540"],
    "noir-santal-inspired-by-santal-33": ["velvet-spice-tobacco-vanille-inspired", "platinum-silk-byredo-gypsy-water-inspired"],
    "velvet-spice-tobacco-vanille-inspired": ["ruby-embrace-inspired-by-tom-ford-s-lost-cherry", "oud-royale-inspired-by-tom-ford-oud-wood"],
    "velvet-nectar-bitter-peach-inspired": ["veloura-ember", "ruby-embrace-inspired-by-tom-ford-s-lost-cherry"],
  };
  const BLEND_WORDS = {
    woody: { a: "Smoked", n: "Timber" }, gourmand: { a: "Candied", n: "Ember" },
    oriental: { a: "Amber", n: "Mirage" }, floral: { a: "Velour", n: "Bloom" },
    citrus: { a: "Gilded", n: "Zest" }, aromatic: { a: "Wild", n: "Sage" },
    signature: { a: "Private", n: "Signature" },
  };
  const blendNameOf = (a, b) => {
    const wa = BLEND_WORDS[familyOf(a)] || BLEND_WORDS.signature;
    const wb = BLEND_WORDS[familyOf(b)] || BLEND_WORDS.signature;
    return wa.a + " " + (wb.n === wa.n ? "Reserve" : wb.n);
  };
  function pairsOf(p) {
    const handles = (LAYER_MAP[p.handle] || []).slice();
    if (handles.length < 2) {
      const moods = (p.tags || []).filter((t) => t.indexOf("mood-") === 0);
      P.filter((o) => o.handle !== p.handle && handles.indexOf(o.handle) === -1 && familyOf(o) !== familyOf(p) && (o.tags || []).some((t) => moods.indexOf(t) !== -1))
        .sort((a, b) => popularityOf(b) - popularityOf(a))
        .forEach((c) => { if (handles.length < 2) handles.push(c.handle); });
      P.filter((o) => o.handle !== p.handle && handles.indexOf(o.handle) === -1)
        .sort((a, b) => popularityOf(b) - popularityOf(a))
        .forEach((c) => { if (handles.length < 2) handles.push(c.handle); });
    }
    return handles.slice(0, 2).map(byHandle).filter(Boolean);
  }

  function productCard(p, opts) {
    opts = opts || {};
    const img2 = p.imgs[1] || p.imgs[0];
    const insp = inspiredOf(p);
    const idx = opts.idx !== undefined ? `<span class="idx">${String(opts.idx).padStart(2, "0")}</span>` : "";
    return `
    <a class="pcard" href="${URLS.product(p.handle)}" ${opts.reveal ? 'data-reveal' : ''} data-cursor="View">
      <div class="ph">
        ${opts.badge ? `<span class="badge">${opts.badge}</span>` : ""}
        ${idx}
        <img class="main" src="${imgW(p.imgs[0], 720)}"
          srcset="${imgW(p.imgs[0], 480)} 480w, ${imgW(p.imgs[0], 720)} 720w, ${imgW(p.imgs[0], 1080)} 1080w"
          sizes="(max-width: 900px) 80vw, 380px" alt="${p.title}" loading="lazy" decoding="async">
        <img class="alt" src="${imgW(img2, 720)}" srcset="${imgW(img2, 480)} 480w, ${imgW(img2, 720)} 720w, ${imgW(img2, 1080)} 1080w" sizes="(max-width: 900px) 80vw, 380px" alt="" loading="lazy" decoding="async" aria-hidden="true">
        <span class="quick" data-add="${p.handle}">Add to Cart — ${money(p.variants[0].p)}</span>
      </div>
      <div class="meta">
        <div class="fam">${genderOf(p)} · ${familyOf(p)}</div>
        <div class="name">${p.title}</div>
        ${insp ? `<div class="insp">Inspired by <b>${insp}</b></div>` : ""}
        <div class="price">From ${money(p.variants[0].p)}${retailOf(p) ? `<s>designer $${retailOf(p)}${retailSizeOf(p) ? ` / ${retailSizeOf(p)}` : ""}</s>` : ""}</div>
        <span class="quick-m" data-add="${p.handle}">Add to Cart \u00B7 ${money(p.variants[0].p)}</span>
      </div>
    </a>`;
  }

  /* ---------- shared chrome ---------- */
  function injectChrome() {
    document.body.classList.add("has-announce");
    const announce = document.createElement("div");
    announce.className = "announce";
    const msg = `<span>10% Off Your First Order — Join the List <i>◆</i> Free U.S. Shipping — Every Order <i>◆</i> $10 Off Any 2 Bottles <i>◆</i> Extrait de Parfum Strength <i>◆</i> 30-Day Returns <i>◆</i></span>`;
    announce.innerHTML = `<div class="marquee">${msg}${msg}</div>`;
    document.body.prepend(announce);

    let header = document.querySelector("header.site-header");
    if (!header) {
    header = document.createElement("header");
    header.className = "site-header";
    header.innerHTML = `
      <div class="wrap">
        <button class="menu-btn" id="menuOpen"><span class="lines"><i></i><i></i></span> <span class="m-txt">Fragrances</span></button>
        <a class="logo" href="${URLS.home}" aria-label="LX Perfume — home"><img class="logo-img" src="https://cdn.shopify.com/s/files/1/0759/6428/5178/files/High-Resolution-Color-Logo-on-Transparent-Background_3.png?v=1749156810" alt="LX Perfume"></a>
        <div class="hright">
          <a class="quiz-btn" href="${URLS.quiz || "/pages/scent-match"}" aria-label="Find your scent — the Scent Match quiz"><span class="q-full">Find My Scent</span><span class="q-short">Quiz</span></a>
          <button class="search-btn" id="searchOpen" aria-label="Search">
            <svg class="hdr-ico" width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"><circle cx="11" cy="11" r="6.5"/><path d="M16 16l4.5 4.5"/></svg>
            <span class="s-txt">Search</span>
          </button>
          <a class="account-btn" href="/account" aria-label="Account">
            <svg class="hdr-ico acc-ico" width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"><circle cx="12" cy="8" r="3.6"/><path d="M4.5 20c1.4-3.6 4.2-5.4 7.5-5.4s6.1 1.8 7.5 5.4"/></svg>
            <span class="acc-txt">Account</span>
          </a>
          <button class="cart-btn" id="cartOpen" aria-label="Cart">
            <svg class="hdr-ico" width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"><path d="M5.5 8h13l-1 12.5h-11z"/><path d="M8.8 10.5V6.8a3.2 3.2 0 0 1 6.4 0v3.7"/></svg>
            <span class="c-txt">Cart</span> <span class="count" id="cartCount">0</span>
          </button>
        </div>
      </div>`;
    document.body.prepend(header);
    }

    const heroVid = (window.LX_VIDEOS || {})["royal-legend-inspired-by-creed-aventus"];
    let menu = document.querySelector(".lx-menu");
    if (menu) {
      // server-rendered menu: only the film side needs the runtime video map
      const ms = menu.querySelector(".mside");
      if (ms && heroVid && !ms.querySelector("video")) ms.innerHTML = `<video src="${heroVid.sd}" muted loop playsinline preload="none"></video>`;
    } else {
    menu = document.createElement("div");
    menu.className = "lx-menu";
    menu.innerHTML = `
      <div class="slats"><i></i><i></i><i></i><i></i><i></i></div>
      <button class="mclose">Close ✕</button>
      <div class="inner" data-lenis-prevent>
        <nav>
          <div class="mgroup">
            <span class="mg-label">Shop by Gender</span>
            <a href="${URLS.shop}" data-img="https://cdn.shopify.com/s/files/1/0759/6428/5178/files/royal-legend-inspired-by-creed-aventus-lxperfume.webp_9.jpg?v=1781025946"><small>01</small> All Fragrances</a>
            <a href="${URLS.shop}?g=women" data-img="https://cdn.shopify.com/s/files/1/0759/6428/5178/files/womens-perfume-royal-whisper-baccarat-rouge-540-inspired-lxperfume.jpg?v=1788283566&width=900"><small>02</small> Women</a>
            <a href="${URLS.shop}?g=men" data-img="https://cdn.shopify.com/s/files/1/0759/6428/5178/files/mens-perfume-wild-legend-dior-sauvage-inspired-lxperfume.jpg?v=1788286093&width=900"><small>03</small> Men</a>
            <a href="${URLS.shop}?g=unisex" data-img="https://cdn.shopify.com/s/files/1/0759/6428/5178/files/unisex-perfume-alviren-zenvor-his-hers-lxperfume.jpg?v=1788288034&width=900"><small>04</small> Unisex</a>
          </div>
          <div class="mgroup">
            <span class="mg-label">The Edits</span>
            <a href="${URLS.bestsellers}" data-img="https://cdn.shopify.com/s/files/1/0759/6428/5178/files/torvane.jpg?v=1784328196"><small>05</small> Best Sellers</a>
            <a href="${URLS.shop}?sort=new" data-img="https://cdn.shopify.com/s/files/1/0759/6428/5178/files/celorin-tight.jpg?v=1785258799"><small>06</small> New Arrivals</a>
            <a href="/pages/fragrance-dupes-list" data-img="https://cdn.shopify.com/s/files/1/0759/6428/5178/files/noir-santal-lxperfume-luxury-campaign_8.jpg?v=1779669829"><small>07</small> The Dupes List</a>
          </div>
          <div class="mgroup">
            <span class="mg-label">Discover</span>
            <a href="/pages/scent-match" data-img="https://cdn.shopify.com/s/files/1/0759/6428/5178/files/Perfume_bottle_with_ingredients_202605231558.jpg?v=1779566347"><small>08</small> Scent Match Quiz</a>
            <a href="/blogs/news" data-img="https://cdn.shopify.com/s/files/1/0759/6428/5178/files/VelvetSpicebyLXPERFUMEscentnoteswithtobaccoleaf_spices_vanilla_cocoa_driedfruits_tonkabean_5.jpg?v=1779567777"><small>09</small> The Journal</a>
            <a href="${URLS.about}" data-img="https://cdn.shopify.com/s/files/1/0759/6428/5178/files/Perfume_bottle_and_gift_box_202605231811.jpg?v=1779574621"><small>10</small> Our Story</a>
            <a href="${URLS.contact}" data-img="https://cdn.shopify.com/s/files/1/0759/6428/5178/files/midnight-silk-lxperfume-bottle-box._2.jpg?v=1779723147"><small>11</small> Contact</a>
          </div>
          <div class="mgroup">
            <span class="mg-label">By Note</span>
            <div class="mg-notes">
              <a href="/collections/vanilla-perfumes">Vanilla</a>
              <a href="/collections/amber-perfume">Amber</a>
              <a href="/collections/sandalwood-perfume">Sandalwood</a>
              <a href="/collections/jasmine-perfume">Jasmine</a>
              <a href="/collections/rose-perfume">Rose</a>
              <a href="/collections/musk-perfume">Musk</a>
              <a href="/collections/cedarwood-perfume">Cedarwood</a>
              <a href="/collections/tonka-bean-perfume">Tonka Bean</a>
            </div>
          </div>
        </nav>
        <div class="mside">
          ${heroVid ? `<video src="${heroVid.sd}" muted loop playsinline preload="none"></video>` : ""}
        </div>
      </div>
      <div class="mfoot"><span>LXPERFUME — Luxury inspired. Honestly priced.</span><span>Extrait de Parfum · Est. MMXXV</span></div>`;
    document.body.appendChild(menu);
    }

    const msideVid = menu.querySelector(".mside video");
    const msideImg = document.createElement("img");
    menu.querySelector(".mside") && menu.querySelector(".mside").appendChild(msideImg);
    msideImg.style.opacity = 0;
    $$("nav a", menu).forEach((a) => {
      a.addEventListener("mouseenter", () => {
        if (a.dataset.img) { msideImg.src = a.dataset.img; msideImg.style.opacity = 0.85; if (msideVid) msideVid.style.opacity = 0; }
      });
      a.addEventListener("mouseleave", () => {
        msideImg.style.opacity = 0; if (msideVid) msideVid.style.opacity = 0.75;
      });
    });
    // .mside is display:none below 901px - never stream the film behind an invisible panel
    const msideMQ = matchMedia("(min-width: 901px)");
    $("#menuOpen").addEventListener("click", () => {
      if (!menu.classList.contains("open")) lockScroll(true);
      menu.classList.add("open"); if (msideVid && msideMQ.matches) msideVid.play().catch(() => {});
    });
    if (msideVid && msideMQ.addEventListener) msideMQ.addEventListener("change", (e) => {
      if (!menu.classList.contains("open")) return;
      if (e.matches) msideVid.play().catch(() => {}); else msideVid.pause();
    });
    menu.querySelector(".mclose").addEventListener("click", () => {
      if (menu.classList.contains("open")) lockScroll(false);
      menu.classList.remove("open"); if (msideVid) msideVid.pause();
    });
    // menu links: release the scroll lock before the curtain navigation
    $$("nav a", menu).forEach((a) => a.addEventListener("click", () => {
      if (menu.classList.contains("open")) lockScroll(false);
      menu.classList.remove("open");
    }));

    // search overlay
    const search = document.createElement("div");
    search.className = "lx-search";
    search.innerHTML = `
      <div class="slats"><i></i><i></i><i></i><i></i><i></i></div>
      <button class="sclose">Close ✕</button>
      <div class="s-scroll" data-lenis-prevent>
        <div class="wrap s-inner">
          <span class="eyebrow">Search the Maison</span>
          <input type="search" id="lxSearchInput" placeholder="A scent, a note, a name…" autocomplete="off" spellcheck="false">
          <div class="s-meta" id="lxSearchMeta"></div>
          <div class="grid-products" id="lxSearchResults"></div>
        </div>
      </div>`;
    document.body.appendChild(search);
    const sInput = search.querySelector("#lxSearchInput");
    const sMeta = search.querySelector("#lxSearchMeta");
    const sRes = search.querySelector("#lxSearchResults");

    /* living placeholder — types real designer names and notes so the customer
       knows exactly what this box understands (same engine as the Dupes Index).
       Runs under prefers-reduced-motion too: character-by-character text is
       cursor-blink-grade, not spatial motion — and Windows' "animation effects
       off" flag was silencing it on desktops (owner-reported). */
    (function () {
      /* owner rule: designer names ONLY inside "Inspired by …" framing;
         the other hints are our collections and scent families */
      const hints = [];
      const EXTRA_HINTS = ["Vanilla Perfumes", "the Woody family", "Tom Ford Alternatives", "the Gourmand family", "Creed Alternatives", "the Floral family", "Sandalwood"];
      let exIdx = 0;
      P.forEach((p, i) => {
        const n = inspiredOf(p);
        if (n) { const h = "Inspired by " + n; if (hints.indexOf(h) === -1) hints.push(h); }
        if (i % 4 === 3 && exIdx < EXTRA_HINTS.length) hints.push(EXTRA_HINTS[exIdx++]);
      });
      if (!hints.length) return;
      const BASE = "Try “", TAIL = "”";
      let ni = 0, ci = 0, dir = 1, holdUntil = 0;
      function frame(now) {
        if (!search.classList.contains("open")) { requestAnimationFrame(frame); return; }
        /* the overlay auto-focuses its input, so focus can't pause the show -
           only actual typing does */
        if (sInput.value) {
          sInput.setAttribute("placeholder", "A scent, a note, a name…");
        } else if (now >= holdUntil) {
          const name = hints[ni];
          ci += dir;
          if (ci >= name.length) { ci = name.length; dir = -1; holdUntil = now + 1500; }
          else if (ci <= 0) { ci = 0; dir = 1; ni = (ni + 1) % hints.length; holdUntil = now + 350; }
          sInput.setAttribute("placeholder", BASE + name.slice(0, ci) + TAIL);
          holdUntil = Math.max(holdUntil, now + (dir === 1 ? 65 : 30));
        }
        requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    })();
    /* ---------- the house search engine — same rules as the collection page ----------
       accent-blind, possessive-blind ("creed's" === "creed"), word-order-blind,
       multi-word AND, squashed runs ("lostcherry"), typo forgiveness within 1 edit */
    const sFold = (s) => {
      s = (s || "").toLowerCase();
      try { s = s.normalize("NFD").replace(/[̀-ͯ]/g, ""); } catch (e) {}
      s = s.replace(/['’]s\b/g, "").replace(/['’]/g, " ");
      return s.replace(/[^a-z0-9\s&]/g, " ").replace(/\s+/g, " ").trim();
    };
    const sSquash = (s) => sFold(s).replace(/[^a-z0-9]/g, "");
    const sHay = {};
    const sHaystack = (p) => {
      if (sHay[p.handle]) return sHay[p.handle];
      const tags = (p.tags || []).filter((t) =>
        !/^(gender:|mood-|scent-)/.test(t) &&
        !/^(Designer Dupe|Inspired Scent|LXPERFUME Collection|Luxury Fragrance|Signature Scent)$/i.test(t)).join(" ");
      const colls = (window.LX_COLLS || []).filter((c) => c.p && c.p.indexOf(p.handle) !== -1).map((c) => c.t).join(" ");
      const spaced = sFold([p.title, inspiredOf(p), tags, colls, familyOf(p), genderOf(p), p.desc || ""].join(" "));
      sHay[p.handle] = { s: spaced, k: spaced.replace(/[^a-z0-9]/g, ""), w: spaced.split(" ") };
      return sHay[p.handle];
    };
    const sWithin1 = (a, b) => {
      if (a === b) return true;
      const la = a.length, lb = b.length;
      if (Math.abs(la - lb) > 1) return false;
      let i = 0, j = 0, diff = 0;
      while (i < la && j < lb) {
        if (a.charAt(i) === b.charAt(j)) { i++; j++; continue; }
        if (++diff > 1) return false;
        if (la === lb) { i++; j++; } else if (la > lb) { i++; } else { j++; }
      }
      return diff + (la - i) + (lb - j) <= 1;
    };
    const searchMatch = (q) => {
      const raw = sFold(q);
      if (!raw) return [];
      const tokens = raw.split(" ").filter(Boolean);
      let hits = P.filter((p) => {
        const h = sHaystack(p);
        return tokens.every((t) => {
          if (h.s.indexOf(t) !== -1) return true;
          const tk = sSquash(t);
          return tk.length > 1 && h.k.indexOf(tk) !== -1;
        });
      });
      if (hits.length) return hits;
      const whole = sSquash(raw);
      if (whole.length > 2) {
        hits = P.filter((p) => sHaystack(p).k.indexOf(whole) !== -1);
        if (hits.length) return hits;
      }
      return P.filter((p) => {
        const h = sHaystack(p);
        return tokens.every((t) => t.length > 3 && h.w.some((w) => sWithin1(t, w)));
      });
    };
    LX.searchMatch = searchMatch;
    function renderSearch() {
      const q = sInput.value.trim();
      let list;
      if (!q) {
        list = P.slice().sort((a, b) => popularityOf(b) - popularityOf(a)).slice(0, 4);
        sMeta.textContent = "Most loved — start typing to search all " + P.length + " scents";
      } else {
        list = searchMatch(q);
        sMeta.textContent = list.length ? list.length + (list.length === 1 ? " scent found" : " scents found") : "Nothing found — try a note, a mood, a name";
      }
      sRes.innerHTML = list.slice(0, 12).map((p, i) => productCard(p, { idx: i + 1 })).join("");
    }
    const openSearch = () => {
      if (!search.classList.contains("open")) lockScroll(true);
      search.classList.add("open"); renderSearch(); setTimeout(() => sInput.focus(), 350);
    };
    const closeSearch = () => {
      if (search.classList.contains("open")) lockScroll(false);
      search.classList.remove("open"); sInput.blur();
    };
    // result-card navigation: release the lock before the curtain transition
    sRes.addEventListener("click", (e) => {
      if (e.target.closest("a.pcard") && !e.target.closest("[data-add]")) closeSearch();
    });
    $("#searchOpen").addEventListener("click", openSearch);
    search.querySelector(".sclose").addEventListener("click", closeSearch);
    sInput.addEventListener("input", renderSearch);
    sInput.addEventListener("keydown", (e) => {
      if (e.key === "Enter" && sInput.value.trim()) window.location.href = "/search?q=" + encodeURIComponent(sInput.value.trim());
    });
    document.addEventListener("keydown", (e) => { if (e.key === "Escape" && search.classList.contains("open")) closeSearch(); });

    let footer = document.querySelector("footer.site-footer");
    if (!footer) {
    footer = document.createElement("footer");
    footer.className = "site-footer";
    footer.innerHTML = `
      <div class="big" data-word="LXPERFUME" aria-hidden="true"></div>
      <div class="wrap">
        <div class="fgrid">
          <div class="fnews">
            <h2 class="fh">The Private List</h2>
            <p style="margin-bottom:1rem">Early access to new scents, private offers, and the art of smelling expensive.</p>
            <input type="email" placeholder="Your email address" aria-label="Email">
            <button class="btn" data-news>Subscribe</button>
          </div>
          <div>
            <h2 class="fh">Explore</h2>
            <a href="${URLS.shop}">The Collection</a>
            <a href="${URLS.bestsellers}">Best Sellers</a>
            <a href="${URLS.shop}?g=women">Women</a>
            <a href="${URLS.shop}?g=men">Men</a>
            <a href="${URLS.shop}?g=unisex">Unisex</a>
            <a href="${URLS.quiz}">Scent Match Quiz</a>
            <a href="${URLS.atelier}">The Blending Atelier</a>
          </div>
          <div>
            <h2 class="fh">Guides</h2>
            <a href="/pages/fragrance-dupes-list">Fragrance Dupes List</a>
            <a href="/pages/perfume-price-per-ml-calculator">Price per ml Calculator</a>
            <a href="/pages/perfume-tracker-app">SCENTUARY &mdash; Scent Wardrobe</a>
            <a href="/collections/tom-ford-alternatives">Tom Ford Alternatives</a>
            <a href="/collections/creed-alternatives">Creed Alternatives</a>
            <a href="/collections/dior-alternatives">Dior Alternatives</a>
          </div>
          <div>
            <h2 class="fh">By Note</h2>
            <a href="/collections/vanilla-perfumes">Vanilla</a>
            <a href="/collections/jasmine-perfume">Jasmine</a>
            <a href="/collections/amber-perfume">Amber</a>
            <a href="/collections/sandalwood-perfume">Sandalwood</a>
            <a href="/collections/rose-perfume">Rose</a>
            <a href="/collections/cedarwood-perfume">Cedarwood</a>
            <a href="/collections/musk-perfume">Musk</a>
            <a href="/collections/tonka-bean-perfume">Tonka Bean</a>
            <a href="/collections/all">All notes &amp; families &#8594;</a>
          </div>
          <div class="fhouse">
            <h2 class="fh">About Us</h2>
            <a href="${URLS.about}">Our Story</a>
            <a href="${URLS.faq}">Atelier Notes</a>
            <a href="${URLS.contact}">Contact</a>
            <a href="/account">My Account &amp; Order Tracking</a>
            <a href="/policies/shipping-policy">Shipping</a>
            <a href="/policies/refund-policy">Returns</a>
          </div>
          <div class="ffollow">
            <h2 class="fh">Follow</h2>
            <a href="https://www.instagram.com/lxperfumeshop/" target="_blank" rel="noopener">Instagram</a>
            <a href="https://www.tiktok.com/@lxperfume" target="_blank" rel="noopener">TikTok</a>
            <a href="https://www.facebook.com/p/LXPerfume-61582178105110/" target="_blank" rel="noopener">Facebook</a>
            <a href="https://www.pinterest.com/llxperfume/" target="_blank" rel="noopener">Pinterest</a>
          </div>
        </div>
        <div class="fbottom">
          <p>© ${new Date().getFullYear()} LXPERFUME — Luxury inspired. Honestly priced. <span style="opacity:.7">· Hand-filled &amp; shipped from Detroit, Michigan</span></p>
          <div style="display:flex;gap:1.6rem">
            <a href="/policies/privacy-policy">Privacy</a>
            <a href="/policies/terms-of-service">Terms</a>
            <a href="/policies/refund-policy">Refunds</a>
          </div>
        </div>
      </div>`;
    document.body.appendChild(footer);
    }
    // the server-rendered trust block (Merchant Center identity) lives above the injected
    // footer for no-JS crawlers; for humans it becomes the fine print between the columns
    // and the copyright bar - one footer, no duplicate address or policy links
    // for humans its pieces join the footer where they fit: email + address under About Us,
    // the house line becomes the copyright row, the disclaimer is the last line of fine print
    const idn = document.querySelector(".lx-identity");
    const fb = footer.querySelector(".fbottom");
    if (idn && fb) {
      const house = footer.querySelector(".fhouse"), contact = idn.querySelector(".lx-identity__contact");
      if (house && contact) house.appendChild(contact);
      const line = idn.querySelector(".lx-identity__line"), copy = fb.querySelector("p");
      if (line && copy) copy.innerHTML = "© " + new Date().getFullYear() + " " + line.innerHTML;
      const note = idn.querySelector(".lx-identity__note");
      if (note) fb.appendChild(note);
      idn.remove();
    }

    // cart drawer
    const veil = document.createElement("div"); veil.className = "cart-veil";
    const drawer = document.createElement("aside"); drawer.className = "cart-drawer";
    drawer.innerHTML = `
      <header><h3>Your Selection</h3><button id="cartClose">Close ✕</button></header>
      <div class="cart-items" id="cartItems" data-lenis-prevent></div>
      <div class="cart-foot">
        <div class="ship-bar" id="shipBar"><span id="shipTxt"></span><div class="sb-line"><i id="shipFill"></i></div></div>
        <div class="cart-pair" id="cartPair"></div>
        <div class="row cart-disc" id="cartDiscount" style="display:none"></div>
        <div class="row"><span>Subtotal</span><b id="cartTotal">$0.00</b></div>
        <button class="btn solid" id="checkoutBtn">Secure Checkout</button>
        <small id="cartFootNote">Free U.S. shipping on every order</small>
        <small style="margin-top:.35rem;opacity:.75">The LX Pledge — no subscriptions, no pre-checked boxes, no surprise charges. Ever.</small>
      </div>`;
    document.body.appendChild(veil); document.body.appendChild(drawer);

    const toast = document.createElement("div"); toast.className = "toast"; document.body.appendChild(toast);

    $("#cartOpen").addEventListener("click", () => { openCart(); refreshCart(); });
    $("#cartClose").addEventListener("click", closeCart);
    veil.addEventListener("click", closeCart);
    $("#checkoutBtn").addEventListener("click", () => { window.location.href = "/checkout"; });
    footer.querySelector("[data-news]").addEventListener("click", () => {
      const em = footer.querySelector("input");
      if (!em.value.includes("@")) { showToast("Enter a valid email"); return; }
      // real Shopify customer subscription (was previously a toast with no backend call)
      const body = "form_type=customer&utf8=%E2%9C%93&contact%5Bemail%5D=" + encodeURIComponent(em.value) + "&contact%5Btags%5D=newsletter";
      fetch("/contact", { method: "POST", headers: { "Content-Type": "application/x-www-form-urlencoded" }, body })
        .catch(() => {});
      em.value = "";
      showToast("Welcome to the Private List");
    });
  }

  /* ---------- native Shopify cart (AJAX Cart API) ---------- */
  let cart = null;

  async function refreshCart() {
    try {
      const res = await fetch("/cart.js", { headers: { Accept: "application/json" } });
      cart = await res.json();
    } catch (e) { console.error("cart fetch failed", e); cart = cart || { items: [], item_count: 0, items_subtotal_price: 0 }; }
    renderCart();
    return cart;
  }

  async function addToCart(handle, vIdx, qty) {
    const p = byHandle(handle); if (!p) return;
    const v = p.variants[vIdx || 0];
    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: v.id, quantity: qty || 1 }] }),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        showToast(err.description || "Could not add to cart");
        return false;
      }
      await refreshCart();
      openCart(); // the drawer opening IS the confirmation - no toast on top of it (owner request)
      return true;
    } catch (e) { console.error(e); showToast("Could not add to cart"); return false; }
  }

  async function changeLine(key, qty) {
    try {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity: qty }),
      });
    } catch (e) { console.error(e); }
    await refreshCart();
  }

  function renderCart() {
    const c = cart || { items: [], item_count: 0, items_subtotal_price: 0 };
    const el = $("#cartCount"); if (el) el.textContent = c.item_count || 0;
    const box = $("#cartItems"); if (!box) return;
    if (!c.items.length) {
      box.innerHTML = `<div class="cart-empty">Your selection is empty.<br>Find the scent that feels like you.</div>`;
    } else {
      box.innerHTML = c.items.map((i) => {
        const img = i.image || ((byHandle(i.handle) || { imgs: [""] }).imgs[0]);
        const vt = i.variant_title ? i.variant_title + " · " : "";
        // fold in ALL discounts (line + automatic cart-level) so the shown price = what they actually pay
        const lineDiscount = (i.discounts || []).reduce((s, d) => s + d.amount, 0);
        const lineNow = (i.original_line_price - lineDiscount) / 100;
        const unitNow = lineNow / i.quantity;
        const unitWas = i.price / 100;
        const hasDisc = lineDiscount > 0;
        return `
        <div class="citem">
          <img src="${imgW(img, 160)}" alt="">
          <div>
            <div class="cn">${i.product_title}</div>
            <div class="cv">${vt}<span class="cv-now">${money(unitNow)}</span>${hasDisc ? ` <s class="cv-was">${money(unitWas)}</s>` : ""}</div>
            <span class="cq">
              <button data-dec="${i.key}">−</button><span>${i.quantity}</span><button data-inc="${i.key}">+</button>
            </span>
          </div>
          <div style="text-align:right">
            <div class="cp">${money(lineNow)}</div>
            <button class="rm" data-rm="${i.key}">Remove</button>
          </div>
        </div>`;
      }).join("");
      $$("[data-rm]", box).forEach((b) => b.addEventListener("click", () => changeLine(b.dataset.rm, 0)));
      $$("[data-inc]", box).forEach((b) => b.addEventListener("click", () => {
        const it = c.items.find((x) => x.key === b.dataset.inc); if (it) changeLine(it.key, it.quantity + 1);
      }));
      $$("[data-dec]", box).forEach((b) => b.addEventListener("click", () => {
        const it = c.items.find((x) => x.key === b.dataset.dec); if (it) changeLine(it.key, it.quantity - 1);
      }));
    }
    const original = (c.items_subtotal_price || 0) / 100;
    const discounted = ((c.total_price != null ? c.total_price : c.items_subtotal_price) || 0) / 100;
    const saved = (c.total_discount || 0) / 100;
    const t = $("#cartTotal");
    if (t) t.innerHTML = saved > 0 ? `${money(discounted)} <s class="cart-was">${money(original)}</s>` : money(discounted);
    const disc = $("#cartDiscount");
    if (disc) {
      if (saved > 0) {
        const title = (c.cart_level_discount_applications && c.cart_level_discount_applications[0] && c.cart_level_discount_applications[0].title) || "Discount applied";
        disc.innerHTML = `<span>${title}</span><b class="cart-save">− ${money(saved)}</b>`;
        disc.style.display = "";
      } else { disc.style.display = "none"; }
    }
    const note = $("#cartFootNote");
    if (note) note.textContent = saved > 0 ? "Discount applied · Free U.S. shipping on every order" : "Free U.S. shipping on every order";
    updateCartExtras(c.items.map((i) => i.handle), original, c.items.reduce((s, i) => s + i.quantity, 0));
  }

  /* pair-deal progress ($10 off any 2 — shipping is free on every order) + layering pair suggestion */
  function updateCartExtras(handlesInCart, subtotal, qty) {
    qty = qty || 0;
    const bar = $("#shipBar"), txt = $("#shipTxt"), fill = $("#shipFill"), pairBox = $("#cartPair");
    const coBtn = $("#checkoutBtn");
    if (coBtn) coBtn.disabled = subtotal <= 0;
    if (txt && fill && bar) {
      if (subtotal <= 0) { txt.textContent = "Free U.S. shipping on every order"; fill.style.transform = "scaleX(0)"; bar.classList.remove("done"); }
      else if (qty < 2) { txt.innerHTML = "Add a 2nd bottle — <b>$10 off</b>"; fill.style.transform = "scaleX(0.5)"; bar.classList.remove("done"); }
      else { txt.textContent = "$10 off unlocked — shipping's free"; fill.style.transform = "scaleX(1)"; bar.classList.add("done"); }
    }
    if (pairBox) {
      pairBox.innerHTML = "";
      if (handlesInCart.length) {
        const base = byHandle(handlesInCart[0]);
        const pair = base && pairsOf(base).find((o) => handlesInCart.indexOf(o.handle) === -1);
        // suggestion earns its space only while it unlocks the $10 - once the pair
        // exists it would just push the checkout button further off a phone screen
        if (pair && qty === 1) {
          const unlocks = qty === 1;
          pairBox.innerHTML = '<img src="' + imgW(pair.imgs[0], 96) + '" alt="">' +
            '<div><div class="cp-k">Layer it — “' + blendNameOf(base, pair) + '”</div><div class="cp-n">' + pair.title + (unlocks ? ' <b style="color:var(--gold-2);font-weight:500">— unlocks $10 off</b>' : "") + "</div></div>" +
            '<button class="cp-add" data-add="' + pair.handle + '">Add · ' + money(pair.variants[0].p) + "</button>";
        }
      }
    }
  }

  /* scroll lock - the page behind an open overlay must not move (iOS-proof) */
  let lockCount = 0, lockY = 0;
  const touchLock = matchMedia("(pointer: coarse)").matches || "ontouchstart" in window;
  function lockScroll(on) {
    const wasLocked = lockCount > 0;
    lockCount = Math.max(0, lockCount + (on ? 1 : -1));
    const locked = lockCount > 0;
    if (locked === wasLocked) return;
    if (locked) {
      lockY = window.scrollY;
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
      if (touchLock) { /* iOS: overflow:hidden alone doesn't stop touch scroll (pre-16) */
        document.body.style.position = "fixed";
        document.body.style.top = -lockY + "px";
        document.body.style.left = "0"; document.body.style.right = "0";
        document.body.style.width = "100%";
      }
      if (lenis) lenis.stop();
    } else {
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
      if (touchLock) {
        document.body.style.position = "";
        document.body.style.top = "";
        document.body.style.left = ""; document.body.style.right = "";
        document.body.style.width = "";
        window.scrollTo(0, lockY);
      }
      if (lenis) { lenis.start(); if (touchLock) lenis.scrollTo(lockY, { immediate: true, force: true }); }
    }
  }

  const openCart = () => {
    document.body.classList.add("lx-overlay");
    const d = $(".cart-drawer");
    if (!d.classList.contains("open")) lockScroll(true);
    $(".cart-veil").classList.add("open"); d.classList.add("open");
  };
  const closeCart = () => {
    document.body.classList.remove("lx-overlay");
    const d = $(".cart-drawer");
    if (d.classList.contains("open")) lockScroll(false);
    $(".cart-veil").classList.remove("open"); d.classList.remove("open");
  };

  let toastTimer;
  function showToast(msg) {
    const t = $(".toast"); t.textContent = msg; t.classList.add("show");
    clearTimeout(toastTimer); toastTimer = setTimeout(() => t.classList.remove("show"), 2600);
  }

  /* ---------- motion ---------- */
  let lenis;
  let revealIO;
  /* phone readability floor: no real text below 10.5px */
  function typeFloor() {
    if (window.innerWidth > 560) return;
    const MIN = 10.5;
    // batched read phase then write phase: interleaving them forces a style recalc per element
    const candidates = $$("main *, .site-footer *, .announce *, .cart-drawer *, .lx-search *, .lx-menu *").filter((el) => {
      if (el.dataset.tf) return false;
      if (el instanceof SVGElement) return false;   /* engraved SVG text keeps its designed size */
      return Array.from(el.childNodes).some((n) => n.nodeType === 3 && /[A-Za-z0-9]/.test(n.textContent));
    });
    const bump = [];
    candidates.forEach((el) => { // READ phase - no writes
      const fs = parseFloat(getComputedStyle(el).fontSize);
      if (fs && fs < MIN) bump.push(el);
    });
    candidates.forEach((el) => { el.dataset.tf = "1"; }); // WRITE phase
    bump.forEach((el) => { el.style.fontSize = MIN + "px"; });
  }
  function scanReveals() {
    if (!revealIO) return;
    typeFloor();
    $$("[data-stagger]:not([data-staggered])").forEach((group) => {
      group.setAttribute("data-staggered", "");
      Array.from(group.children).forEach((k, i) => { k.setAttribute("data-reveal", ""); k.style.transitionDelay = (i * 0.09) + "s"; });
    });
    $$("[data-fxtitle]:not([data-fxtitle-on])").forEach((el) => {
      el.setAttribute("data-fxtitle-on", "1");
      FX.scrollTitle(el);
    });
    $$("[data-reveal]:not(.in), .mask-img:not(.in), [data-split]:not(.split-done)").forEach((el) => revealIO.observe(el));
    FX.liquidHover();
    FX.magnetic();
  }

  function initMotion() {
    /* the reveals never wait for a CDN: the observer exists before any gsap call */
    window.addEventListener("scroll", onScrollClass, { passive: true });
    onScrollClass();
    revealIO = new IntersectionObserver((es) => es.forEach((e) => {
      if (e.isIntersecting) { e.target.classList.add("in", "split-done"); revealIO.unobserve(e.target); }
    }), FX.touch ? { threshold: 0, rootMargin: "0px 0px 240px 0px" } : { threshold: 0.12 });
    scanReveals();
    if (!window.gsap || !window.ScrollTrigger) return;
    gsap.registerPlugin(ScrollTrigger);
    // touch scrolling is native under Lenis smoothWheel anyway - skip the permanent rAF cost on touch
    if (typeof Lenis !== "undefined" && !FX.touch) {
      lenis = new Lenis({ duration: 1.3, smoothWheel: true });
      lenis.on("scroll", ScrollTrigger.update);
      gsap.ticker.add((t) => lenis.raf(t * 1000));
      gsap.ticker.lagSmoothing(0);
    }

    $$("[data-split]").forEach((el) => {
      const lines = el.innerHTML.split("<br>");
      el.innerHTML = lines.map((l) => `<span class="split-line"><span>${l}</span></span>`).join("");
      Array.from(el.querySelectorAll(".split-line > span")).forEach((s, i) => s.style.transitionDelay = (0.1 + i * 0.12) + "s");
    });

    $$("[data-plx]").forEach((el) => {
      const amt = parseFloat(el.dataset.plx) || 15;
      gsap.fromTo(el, { yPercent: -amt / 2 }, {
        yPercent: amt / 2, ease: "none",
        scrollTrigger: { trigger: el.parentElement, start: "top bottom", end: "bottom top", scrub: true },
      });
    });

    $$("[data-count]").forEach((el) => {
      const target = parseFloat(el.dataset.count);
      const suffix = el.dataset.suffix || "";
      ScrollTrigger.create({
        trigger: el, start: "top 85%", once: true,
        onEnter: () => {
          const o = { v: 0 };
          gsap.to(o, { v: target, duration: 2, ease: "power3.out", onUpdate: () => { el.textContent = Math.round(o.v).toLocaleString() + suffix; } });
        },
      });
    });
  }

  function onScrollClass() { if (lockCount > 0) return; document.body.classList.toggle("scrolled", window.scrollY > 40); }

  function preloader(done) {
    const pl = $("#preloader");
    if (!pl) { done && done(); return; }
    const pct = pl.querySelector(".pl-pct");
    const o = { v: 0 };
    const tl = gsap.timeline({ onComplete: () => { pl.style.display = "none"; document.body.classList.remove("preloading"); done && done(); } });
    tl.fromTo(".pl-logo", { opacity: 0, letterSpacing: "0.8em" }, { opacity: 1, letterSpacing: "0.34em", duration: 1, ease: "power3.out" })
      .to(o, { v: 100, duration: 1.4, ease: "power2.inOut", onUpdate: () => { if (pct) pct.textContent = String(Math.round(o.v)).padStart(3, "0"); } }, "-=0.6")
      .to(pl.querySelectorAll(".pl-slats i"), { scaleY: 0, transformOrigin: "top", duration: 0.8, ease: "expo.inOut", stagger: 0.06 }, "+=0.1")
      .to(".pl-logo, .pl-pct, .pl-sub", { opacity: 0, duration: 0.4 }, "<");
  }

  /* ---------- boot ---------- */
  function boot(pageInit) {
    injectChrome();
    refreshCart();
    FX.init();
    try { initMotion(); } catch (e) { console.error("motion init failed", e); }
    document.addEventListener("click", (e) => {
      const a = e.target.closest("[data-add]");
      if (a) { e.preventDefault(); e.stopPropagation(); addToCart(a.dataset.add, +(a.dataset.v || 0), 1); }
    });
    try { if (pageInit) pageInit(); } catch (e) { console.error("page init failed", e); }
    scanReveals();
    window.addEventListener("load", () => { scanReveals(); if (typeof ScrollTrigger !== "undefined") ScrollTrigger.refresh(); });
    // back/forward cache restore: reset overlays, scroll lock and stale state
    window.addEventListener("pageshow", (e) => {
      if (!e.persisted) return;
      $$(".lx-menu.open, .lx-search.open, .cart-drawer.open, .cart-veil.open").forEach((el) => el.classList.remove("open"));
      lockCount = 0;
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      document.body.style.width = "";
      if (lenis) lenis.start();
      refreshCart(); // cart may have changed on the page we are returning from
      if (typeof ScrollTrigger !== "undefined") ScrollTrigger.refresh();
    });
    preloader();
    // exit-intent quiz popup retired (owner request) — the header "Find My Scent" button replaces it
  }

  /* ---------- exit intent: one quiet invitation to the quiz, once per session, desktop only ---------- */
  function initExitIntent() {
    if (matchMedia("(pointer: coarse)").matches) return;              // desktop mouse only
    if (location.pathname.indexOf("/pages/scent-match") === 0) return; // never on the quiz itself
    if (location.pathname.indexOf("/checkout") === 0) return;
    try { if (sessionStorage.getItem("lx_exit")) return; } catch (e) {}
    let armed = false;
    setTimeout(() => { armed = true; }, 12000); // never fire in the first 12s — only on a real visit
    document.documentElement.addEventListener("mouseleave", function onLeave(e) {
      if (!armed || e.clientY > 8) return;
      if (document.querySelector(".cart-drawer.open, .lx-menu.open, .lx-search.open")) return;
      document.documentElement.removeEventListener("mouseleave", onLeave);
      try { sessionStorage.setItem("lx_exit", "1"); } catch (err) {}
      const ov = document.createElement("div");
      ov.className = "exit-veil";
      ov.innerHTML =
        '<div class="exit-card" role="dialog" aria-modal="true" aria-label="Find your scent">' +
        '<button class="exit-x" aria-label="Close">✕</button>' +
        '<span class="exit-eyebrow">Before you go</span>' +
        '<h3 class="exit-h">Four questions.<br><em>Your signature scent.</em></h3>' +
        '<p class="exit-p">45 extraits is a lot of doors. The Scent Match opens the right one in under two minutes.</p>' +
        '<a class="btn solid exit-cta" href="' + URLS.quiz + '">Find My Scent</a>' +
        '<button class="exit-skip">No thanks — keep browsing</button>' +
        "</div>";
      document.body.appendChild(ov);
      requestAnimationFrame(() => ov.classList.add("show"));
      const close = () => { ov.classList.remove("show"); setTimeout(() => ov.remove(), 450); };
      ov.addEventListener("click", (ev) => { if (ev.target === ov) close(); });
      ov.querySelector(".exit-x").addEventListener("click", close);
      ov.querySelector(".exit-skip").addEventListener("click", close);
      document.addEventListener("keydown", function esc(ev) { if (ev.key === "Escape") { close(); document.removeEventListener("keydown", esc); } });
    });
  }

  return { $, $$, money, P, byHandle, videoOf, inspiredOf, genderOf, familyOf, popularityOf, retailOf, retailSizeOf, pairsOf, blendNameOf, productCard, addToCart, boot, showToast, scanReveals, URLS, get lenis() { return lenis; } };
})();

/* templates define window.LX_PAGE_INIT before this script loads */
LX.boot(window.LX_PAGE_INIT || null);
